export default "__VITE_ASSET__BzDaxptw__"